﻿import { GroupSearch } from "../../../../Fundraising.UI.Shared/Modules/search/GroupSearch";
import Switchery from "../../../../Fundraising.UI.Shared/Vendor/switchery/js/switchery";
import "jquery-mask-plugin";
import { SaveButton } from "../../../../Fundraising.UI.Shared/Modules/formTools/SaveButton";
import { Share } from "../../../../Fundraising.UI.Shared/Modules/Share";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Account = {};

    // Private Variables
    let returningPartipant, safetyPledge, safetyVideoPledge, loginBtn;

    const modalSwitchDelay = 250;

    const setLoginBtn = () => {
        const $submitBtn = $("#account-login");

        loginBtn = new SaveButton("#account-login", {
            "savingLabel": $submitBtn.data("saving-label"),
            "savedLabel": $submitBtn.data("saved-label")
        });
        //console.log(loginBtn);
    }

    const setRegistrationLoginToggle = function () {

        /* Choose Registration or login */
        $(document).on("click", ".login-trigger:not(disabled)", function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $participantChooser = $(".participant-chooser");
            const $loginForm = $(".login-form");

            $btn.addClass("disabled");

            $participantChooser.fadeOut(function () {
                $loginForm.css('display', 'none').removeClass('hidden').toggle("slide");
            });
        });

        // Confirm School 
        $(document).on("click", ".yes.confirm-reg:not(.disabled)", function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $verifyForm = $("#verify-detail-form");
            $btn.addClass('disabled').attr('disabled', 'disabled');
            $verifyForm.trigger("submit");            
        });
    }

    const setCampaignVideoSwitches = () => {
        const $profilePhotoIframe = parent.$("#iframe-campaign-video-modal");
        $profilePhotoIframe.on("load", function () {
            setModalSwitches("set-storefront-video", M2.CampaignMedia.saveVideoStorefrontStatus);
        });
    }

    const setModalSwitches = (switchId, callback) => {
        window.setTimeout(function () {
            const profileImageSwitch = createModalSwitch(switchId);
            profileImageSwitch.onChangeSuccess = function (state) {
                callback();
            }
        }, modalSwitchDelay);
    }

    const createModalSwitch = (id) => {
        const checkbox = document.getElementById(id);
        // Remove any previous switches before creating a new one
        $('.switchery.small-switch').remove();
        const switchery = new Switchery(checkbox, { className: 'switchery small-switch' });
        return switchery;
    }

    function restoreTeacherSelectDefault() {
        $(".basics-panel").removeClass("show-leader-entry").removeClass("show-leader-select");
        $("#no-teacher").prop("checked", false);
        $("input[type='hidden'][name='TeacherUnknown']").val(false);
        $("#TeacherLastNameSelect").html("").trigger("change.select2");
    }

    function setCOPPAStatus(classStatus) {
        const $verfiyStep = $('#registration-form .verify-step.two');
        const $coppaCheckboxes = $(".coppa-checkboxes :checkbox");

        $verfiyStep.removeClass('guardian');
        $verfiyStep.removeClass('participant-over-13');
        $verfiyStep.removeClass('participant-under-13');

        // Check the checkboxes so they validate
        if (classStatus !== 'guardian') $coppaCheckboxes.prop("checked", true);
        else $coppaCheckboxes.prop("checked", false);

        $verfiyStep.addClass(classStatus);
    }
    function setUpAgeChooser() {
        // School Change labels


        $("input:radio[name=RegistrantType]").click(function () {
            var value = $(this).val();
            const $DisplayCOPPAConfirmation = $('#RequiresCOPPA');
            let tmpFirstNameLabel, tmpLastNameLabel, tmpEmailLabel;
            switch (value) {
                case "Guardian":
                    tmpFirstNameLabel = M2.Account.config.parentFirstNameLabel;
                    tmpLastNameLabel = M2.Account.config.parentLastNameLabel;
                    tmpEmailLabel = M2.Account.config.parentEmailLabel;
                    $DisplayCOPPAConfirmation.val(true);
                    setCOPPAStatus("guardian");
                    break;

                case "Participant":
                    tmpFirstNameLabel = M2.Account.config.studentFirstNameLabel;
                    tmpLastNameLabel = M2.Account.config.studentLastNameLabel;
                    tmpEmailLabel = M2.Account.config.studentEmailLabel;
                    $DisplayCOPPAConfirmation.val(false);
                    setCOPPAStatus("participant-over-13");
                    break;

                default:
                    tmpFirstNameLabel = M2.Account.config.parentFirstNameLabel;
                    tmpLastNameLabel = M2.Account.config.parentLastNameLabel;
                    tmpEmailLabel = M2.Account.config.parentEmailLabel;
                    $DisplayCOPPAConfirmation.val(false);
                    setCOPPAStatus("participant-under-13");
                    break;
            }

            $(".field-grp.first-name label").html(tmpFirstNameLabel);
            $(".field-grp.last-name label").html(tmpLastNameLabel);
            $(".field-grp.email label").html(tmpEmailLabel);
            $(".field-grp.email.last label").html("Confirm Email");
        });
    }
    function submitForm(form) {
        $(form).trigger("submit");
    }

    function selectAddress() {
        $(document).on("click", ".select-address.btn", function (e) {
            e.preventDefault();
            $(".address-suggestions input[type='radio']:checked").each(function () {
                const targetId = $(this).val();
                const $target = $(targetId);

                if ($target.attr("id") !== "address-choice-default") {
                    $("#AddressLine1").val($target.find(".address1").html());
                    $("#AddressLine2").val($target.find(".address2").html());
                    $("#City").val($target.find(".city").html());
                    $("#State").val($target.find(".state").html());
                    $("#Zip").val($target.find(".zip").html());
                }
            });
            submitForm(".update-participant-details #form0");
            M2.Modal.hide();
        });
    }

    function disableSelect2($select, state) {
        $select.prop('disabled', state).trigger("change.select2");
        var parentContainer = $select.closest('div');
        if (state === true) parentContainer.addClass('disabled');
        else parentContainer.removeClass('disabled');
    }

    function setNoTeacher() {
        $(document).on("click", "#no-teacher", function (e) {
            var $teacherSelect = $(".teacher-identifier select");

            if ($(this).prop("checked")) {
                $teacherSelect.val($teacherSelect.find("option:first").val());
                disableSelect2($teacherSelect, true);

                //$("#TeacherLastName").val();
                $(".basics-panel").addClass("show-leader-entry");
                $("input[type='hidden'][name='TeacherUnknown']").val(true);

            } else {
                //$(".enter-teacher-info").val("");
                disableSelect2($teacherSelect, false);
                $(".basics-panel").removeClass("show-leader-entry");
                $("input[type='hidden'][name='TeacherUnknown']").val(false);
            }

        });
    }
    function scrollToElem(elem) {
        $('html, body').animate({
            scrollTop: $(elem).offset().top
        }, 2000);
    }
    // Activate button after scrolling
    function activateOnScroll(container, button) {
        if (container.scrollTop() + container.innerHeight() >= (container[0].scrollHeight * .8)) {
            button.removeClass("disabled");
        }
    }

    const getReturningUserUrl = () => {
        const getRedirectUrl = $("#FirstLogInReturnUrl").val();
        return $.ajax({
            url: getRedirectUrl
        });
    }

    function verifySetUp() {
        // Set the status of returning participants and safety pledge
        const $contentContainer = $("div.content-container");
        returningPartipant = $contentContainer.hasClass("returning-participant");
        safetyPledge = $contentContainer.hasClass("safety-pledge-required");
        safetyVideoPledge = $contentContainer.hasClass("safety-video-required");

        // Check against Zip Code
        $(document).on("click", ".btn.check-zip-code", function (e) {
            $("#registration-form").hide();
            $('#verify-detail-form')[0].reset();
            submitForm("#verify-council-form");
        });

        // Safety Video Events
        if (safetyVideoPledge) {
            $(document).on("click", ".proceed-past-training .btn.disabled", function (e) {
                e.preventDefault();
            });
        }

        // Show Guardian Pledge
        $(document).on("click", ".proceed-past-training-video .btn", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                $("#safety-pledge-guardian-step").removeClass("hidden").slideDown();
                scrollToElem("#safety-pledge-guardian-step");
                activateOnScroll($('.guardian-safety-pledge-container'), $(".proceed-past-guardian-pledge a.btn"));
            }
        });

        // Enable Next button after reading Guardian Pledge
        $('.guardian-safety-pledge-container').on('scroll', function () {
            activateOnScroll($(this), $(".proceed-past-guardian-pledge a.btn"));
        });

        // Show Participant Pledge
        $(document).on("click", " .proceed-past-guardian-pledge .btn", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                $("#safety-pledge-participant-step").removeClass("hidden").slideDown();
                scrollToElem("#safety-pledge-participant-step");
                activateOnScroll($('.participant-safety-pledge-container'), $(".proceed-past-participant-pledge a.btn"));

            }
        });

        // Enable Next button after reading Participant Pledge
        $('.participant-safety-pledge-container').on('scroll', function () {
            activateOnScroll($(this), $(".proceed-past-participant-pledge a.btn"));
        });

        // Show Account Details
        $(document).on("click", ".proceed-past-participant-pledge .btn", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                if (returningPartipant) {
                    getReturningUserUrl().done(function (data) {
                        const returnUrl = data;
                        window.location.href = returnUrl;
                    });
                }
                else {
                    $("#registration-form").removeClass("hidden").slideDown();
                    scrollToElem("#registration-form");
                }
            }
        });

        $(document).on("click", ".confirm-school.btn", function (e) {
            e.preventDefault();
            const $contentContainer = $("div.content-container");
            returningPartipant = $contentContainer.hasClass("returning-participant");
            if (returningPartipant) {
                getReturningUserUrl().done(function (data) {
                    const returnUrl = data;
                    window.location.href = returnUrl;
                });
            }
            else {
                $("#registration-form").removeClass("hidden").slideDown();
                scrollToElem("#registration-form");
            }
        });


        $(document).on("click", ".returning-participant a.change-school", function (e) {
            e.preventDefault();
            $(".confirm-school-msg").html(M2.Account.config.noSchoolText).fadeIn("slow");
        });
    }
    function basicsConfirmation() {
        $(document).on("click", ".basics.next", function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) return false;

            var modalTitle = $(this).data('modal-title');
            var modalContent = $(this).data('modal-content');
            var modalId = $(this).data('modal-id');

            // Populate First Name
            $("#particpant-first-name .data-label").html($(".field-grp.first-name label").html() + ":");
            $("#particpant-first-name .data-value").html($("#ParticipantFirstName").val());

            // Populate Last Name
            $("#particpant-last-name .data-label").html($(".field-grp.last-name label").html() + ":");
            $("#particpant-last-name .data-value").html($("#ParticipantLastName").val());

            // Grab Nickname Label and populate
            var nicknameLabel = $(".field-grp.nick-name label").clone();
            nicknameLabel.find("span").remove();
            nicknameLabel = nicknameLabel.html();

            if ($("#ParticipantNickName").val().length > 0) {
                $("#participant-nickname").show();
                $("#participant-nickname .data-label").html(nicknameLabel + ":");
                $("#participant-nickname .data-value").html($("#ParticipantNickName").val());
            } else {
                $("#participant-nickname").hide();
            }

            // GSA Specific fields

            if ($(this).hasClass("gsa")) {
                let selectedOption = $("#GroupIdentifier option:selected").text();
                if ($("#GroupUnknown").is(':checked')) selectedOption = M2.Account.config.groupNotSelectedText;
                $("#participant-group .data-value").html(selectedOption);
            }

            // School Specific fields

            if ($(this).hasClass("school")) {
                const grade = $("#UnitId :selected").text();
                const $teacherSelected = $("#TeacherLastNameSelect :selected");
                const selectedTeacher = $teacherSelected.text();
                let teacher;
                if (selectedTeacher !== "" && $teacherSelected.prop("disabled") !== true) teacher = selectedTeacher;
                else teacher = $("#TeacherLastName").val();
                $("#grade .data-value").html(grade);
                $("#teacher-name .data-value").html(teacher);
            }

            // If we are validating a form before the overlay, check
            if ($(this).hasClass("valid-form") && !$(this).closest("form").valid()) {
                try {
                    $("html, body").animate({ scrollTop: $('.field-validation-error:visible:first').closest('.form-group').offset().top }, "fast");
                } catch (e) {
                    console.log(e);
                }
                return false;

            }

            // Stop the video if it's playing on Basics
            M2.Util.stopMediaPlayer();

            // Open Overlay
            M2.Modal.create(modalId, modalTitle, modalContent, null, true);
        });

        $(document).on("click", ".yes.btn", function (e) {
            $('#basics-form').submit();
            $(this).addClass('disabled').attr('disabled', 'disabled');
            $('.basics.btn').addClass('disabled').attr('disabled', 'disabled');
        });
    }
    function registrationConfirmation() {
        // If registration overlay, populate first and last name, school, and type
        $(document).on("click", ".sign-up.school", function (e) {
            e.preventDefault();

            var modalId = $(this).attr("data-modal-id");
            var modalTitle = $(this).attr("data-modal-title");
            var modalContent = $(this).attr("data-modal-content");

            var registrant = $("#FirstName").val() + " " + $("#LastName").val();
            var school = $("#active-org.org-name").text();
            var location = $("#active-location.org-location").text();
            var regtype = $('.age input:radio[name=RegistrantType]:checked').val();
            var email = $("#ConfirmEmail").val();

            $("#orginization-name-preview .data-value").html(school);
            $("#orginization-location-preview .data-value").html(location);
            $("#name-preview .data-value").html(registrant);
            $("#registration-type-preview .data-value").html(regtype);
            $("#email-preview .data-value").html(email);

            // If we are validating a form before the overlay, check
            if ($(this).hasClass("valid-form") && !$(this).closest("form").valid()) {
                return false;
            }

            // Stop the video if it's playing on Basics
            if ($(this).hasClass("valid-form") && $(this).hasClass("next")) {
                M2.Util.stopMediaPlayer();
            }

            // Open Overlay
            M2.Modal.create(modalId, modalTitle, modalContent, null, true);

        });
    }
    function manageUnverifiedParticipants() {
        $(document).on("click", ".btn.view.disabled", function (e) {
            e.preventDefault();
        });
    }

    function populatePreview() {
        $('.basics input.preview').each(function (index, value) {
            var tmpTarget = $(this).attr("data-for");
            let currency, previewValue;
            if ($(this).hasClass("currency")) currency = true;
            else currency = false;

            if (currency) {
                previewValue = $(this).val().replace(/[A-Za-z$-]/g, '');
                previewValue = "$" + M2.Util.addCommas(previewValue);
            } else {
                previewValue = $(this).val();
            }

            if (tmpTarget === "gs-goal-amt-nuts") $("#gs-goal-amt-nuts").removeClass("hidden");

            if (previewValue !== "") $("#" + tmpTarget).html(previewValue);
            else $("#" + tmpTarget).html($(this).data("default-text"));
        });
    }

    function setConfigOptions() {
        // Set config options
        /* global M2_Account_noCouncilText, M2_Account_wrongCouncilText, M2_Account_wrongCouncilReturningText, M2_groupNotSelectedText, 
        M2_Account_selectParticipantInstructionalText, M2_Account_selectScoutNameNotVisibleText,  M2_Account_GSA_SelectParticipantNoParticipantsText,M2_Account_GSA_SelectParticipantNotFoundText,
        M2_Account_GSA_SelectParticipantFoundText,M2_Account_GSA_GroupNotSelectedText,M2_Account_GSA_GroupUnknownText,M2_Account_GSA_ParticipantNotFoundText,
        M2_Account_GSA_ParticipantFoundText,M2_Account_suppliedAddressLabel,M2_Account_verifiedAddressLabel,M2_Account_noResultsText
        M2_Account_addressEnteredText,M2_Account_parentFirstNameLabel,M2_Account_parentLastNameLabel,M2_Account_parentEmailLabel,M2_Account_studentFirstNameLabel
        M2_Account_studentLastNameLabel, M2_Account_studentEmailLabel,M2_Account_noSchoolText   */
        if ('undefined' !== typeof M2_Account_noCouncilText) M2.Account.config.noCouncilText = M2_Account_noCouncilText;
        if ('undefined' !== typeof M2_Account_wrongCouncilText) M2.Account.config.wrongCouncilText = M2_Account_wrongCouncilText;
        if ('undefined' !== typeof M2_Account_wrongCouncilReturningText) M2.Account.config.wrongCouncilReturningText = M2_Account_wrongCouncilReturningText;
        if ('undefined' !== typeof M2_groupNotSelectedText) M2.Account.config.groupNotSelectedText = M2_groupNotSelectedText;
        if ('undefined' !== typeof M2_Account_selectParticipantInstructionalText) M2.Account.config.selectParticipantInstructionalText = M2_Account_selectParticipantInstructionalText;
        if ('undefined' !== typeof M2_Account_selectScoutNameNotVisibleText) M2.Account.config.selectScoutNameNotVisibleText = M2_Account_selectScoutNameNotVisibleText;
        if ('undefined' !== typeof M2_Account_GSA_SelectParticipantNoParticipantsText) M2.Account.config.GSA_SelectParticipantNoParticipantsText = M2_Account_GSA_SelectParticipantNoParticipantsText;
        if ('undefined' !== typeof M2_Account_GSA_SelectParticipantNotFoundText) M2.Account.config.GSA_SelectParticipantNotFoundText = M2_Account_GSA_SelectParticipantNotFoundText;
        if ('undefined' !== typeof M2_Account_GSA_SelectParticipantFoundText) M2.Account.config.GSA_SelectParticipantFoundText = M2_Account_GSA_SelectParticipantFoundText;
        if ('undefined' !== typeof M2_Account_GSA_GroupNotSelectedText) M2.Account.config.GSA_GroupNotSelectedText = M2_Account_GSA_GroupNotSelectedText;
        if ('undefined' !== typeof M2_Account_GSA_GroupUnknownText) M2.Account.config.GSA_GroupUnknownText = M2_Account_GSA_GroupUnknownText;
        if ('undefined' !== typeof M2_Account_GSA_ParticipantNotFoundText) M2.Account.config.GSA_ParticipantNotFoundText = M2_Account_GSA_ParticipantNotFoundText;
        if ('undefined' !== typeof M2_Account_GSA_ParticipantFoundText) M2.Account.config.GSA_ParticipantFoundText = M2_Account_GSA_ParticipantFoundText;
        if ('undefined' !== typeof M2_Account_suppliedAddressLabel) M2.Account.config.suppliedAddressLabel = M2_Account_suppliedAddressLabel;
        if ('undefined' !== typeof M2_Account_verifiedAddressLabel) M2.Account.config.verifiedAddressLabel = M2_Account_verifiedAddressLabel;
        if ('undefined' !== typeof M2_Account_noResultsText) M2.Account.config.noResultsText = M2_Account_noResultsText;
        if ('undefined' !== typeof M2_Account_addressEnteredText) M2.Account.config.addressEnteredText = M2_Account_addressEnteredText;
        if ('undefined' !== typeof M2_Account_parentFirstNameLabel) M2.Account.config.parentFirstNameLabel = M2_Account_parentFirstNameLabel;
        if ('undefined' !== typeof M2_Account_parentLastNameLabel) M2.Account.config.parentLastNameLabel = M2_Account_parentLastNameLabel;
        if ('undefined' !== typeof M2_Account_parentEmailLabel) M2.Account.config.parentEmailLabel = M2_Account_parentEmailLabel;
        if ('undefined' !== typeof M2_Account_studentFirstNameLabel) M2.Account.config.studentFirstNameLabel = M2_Account_studentFirstNameLabel;
        if ('undefined' !== typeof M2_Account_studentLastNameLabel) M2.Account.config.studentLastNameLabel = M2_Account_studentLastNameLabel;
        if ('undefined' !== typeof M2_Account_studentEmailLabel) M2.Account.config.studentEmailLabel = M2_Account_studentEmailLabel;
        if ('undefined' !== typeof M2_Account_noSchoolText) M2.Account.config.noSchoolText = M2_Account_noSchoolText;
    }

    const resetCampaignParticipant = () => {
        const $campaignParticipant = $("#CampaignParticipantId");
        $campaignParticipant.val(-1);
    };

    const searchTroop = () => {

        const groupIdentifierSearchUrl = $("#GroupIdentifier").data("group-identifier-search-url");

        const groupSelect = new GroupSearch(".basics-panel #GroupIdentifier", {
            placeholder: "Choose...",
            groupSearchUrl: groupIdentifierSearchUrl,
            paramName: "Identifier",
            width: "auto",
            minInputLength: 1,
            dropdownAutoWidth: true,
            minimumResultsForSearch: 10
        }).onSelect((data) => {
            const groupId = data.id;
            const identifier = data.text;
            $("#GroupUnknown").prop('checked', false);
            M2.Account.setParticipantSearchMode('show-participant-search');
            $("#GroupId").val(groupId);
            $("#GroupIdentifier option:selected").val(identifier);
            
        });
    }

    const setUnitInputMask = () => {
        $('body').on("focus", ".unit.form-control:not(.inactive)", function () {
            $(this).mask('0#');
        });
    }

    const setGoalMask = () => {
        $(".campaign-school #Goal, .campaign-gm #Goal").mask("###,###,###", {
            reverse: true,
            onComplete: function (firstDigit, e) {
                if (firstDigit == 0) {
                    e.target.value = e.target.value.replace(/^0+/, '');
                }
            }
        });
    }

    const removeParticipant = (url, data) => {
        return $.ajax({
            url: url,
            type: "POST",
            data: data
        });
    };

    const setRemoveParticipantManagePage = () => {
        $(document).on("click", ".account-details .delete-participant", function (e) {
            e.preventDefault();
            const $trigger = $(this);
            const removeUrl = $trigger.attr("href");
            const confirmDialog = $trigger.data("ajax-confirm");
            const target = $trigger.data("ajax-update");
            const token = $trigger.closest("form").find('input[name="__RequestVerificationToken"]').val();
            const participantId = $trigger.data("participant-id");
            if (!confirm(confirmDialog)) return false;
            $trigger.attr("disabled", true).addClass("disabled");

            const data = {
                "__RequestVerificationToken": token,
                "campaignParticipantId": participantId
            }
            removeParticipant(removeUrl, data).done(function (data) {
                $(target).html(data); 
            }).fail(function () {
                alert("There was an error removing the participant. Please try again.");
                $trigger.attr("disabled", false).removeClass("disabled");
            });
        });
    }

    const setShareSite = () => {
    // share-btn
    const shareBtns = document.querySelectorAll('.share-btn');
    shareBtns.forEach((btn) => {
        const webshare = Share.create(btn, {
            url: btn.dataset.shareUrl,
            text: btn.dataset.shareText,
            culture: "en-US",
            fetchUrl: true
        });
    });
    }

    M2.Account = {
        config: {
            name: "M2 Account",
            parentFirstNameLabel: "Parent or Guardian's First Name",
            parentLastNameLabel: "Parent or Guardian's Last Name",
            parentEmailLabel: "Parent or Guardian's Email",
            studentFirstNameLabel: "Your First Name",
            studentLastNameLabel: "Your Last Name",
            studentEmailLabel: "Your Email",
            noResultsText: "No results found.",
            selectTeacherInstructionalText: "Choose...",
            selectParticipantInstructionalText: "Choose One",
            selectScoutNameNotVisibleText: "I don’t see her name",
            GSA_SelectParticipantNoParticipantsText: "Please enter your Girl Scout's first and last name below. Once saved, this name cannot be changed.",
            GSA_SelectParticipantNotFoundText: "The Girl Scout that will be registered appears below, if this is not correct please search again using the tool above.",
            GSA_SelectParticipantFoundText: "Your Girl Scout's name appears below. Once saved, this name cannot be changed.",
            suppliedAddressLabel: "Your Address",
            verifiedAddressLabel: "Verified Address",
            noCouncilText: "",
            wrongCouncilText: ""
        },
        init: function () {
            setConfigOptions();
            setRegistrationLoginToggle();
            M2.Account.setBasicsTriggers();
            searchTroop();
            selectAddress();
            setNoTeacher();
            verifySetUp();
            setUpAgeChooser();
            basicsConfirmation();
            registrationConfirmation();
            manageUnverifiedParticipants();
            setCampaignVideoSwitches();
            setUnitInputMask();
            setGoalMask();
            setLoginBtn();
            setRemoveParticipantManagePage();
            setShareSite();
        },
        setBasicsTriggers: function () {
            populatePreview();

            // Group Unkown 
            $(document).on("change", "#GroupUnknown", function () {
                resetCampaignParticipant();
                if ($(this).is(':checked')) {
                    M2.Account.setParticipantSearchMode('group-unknown');
                } else {
                    M2.Account.setParticipantSearchMode('group-not-selected');
                }
            });

            $(document).on('click', '.choose-participant input[type=radio]', function (e) {
                $('.choose-tools .btn').removeClass('disabled');
            });

            $(document).on('click', '.choose-tools button:not(.disabled)', function (e) {
                e.preventDefault();
                var $selectedParticipant = $("input[name='participant-name']:checked");
                var firstName = $selectedParticipant.closest('.radio-grp').find('input.first-name').val();
                var lastName = $selectedParticipant.closest('.radio-grp').find('input.last-name').val();
                var nickName = $selectedParticipant.closest('.radio-grp').find('input.nick-name').val();
                const isNotFound = $selectedParticipant.attr('id') === 'no-name';
                const participantResult = isNotFound ? 'participant-not-found' : 'participant-found';
                const campaignParticipantId = isNotFound ? '-1' : $selectedParticipant.val();

                window.parent.$('.participant-search-container .first-name input[type=text]').val(firstName);
                window.parent.$('.participant-search-container .last-name input[type=text]').val(lastName);
                window.parent.$('#ParticipantNickName').val(nickName);
                window.parent.$('#CampaignParticipantId').val(campaignParticipantId);
                window.parent.M2.Account.setParticipantSearchMode(participantResult);
                window.parent.$('.modal').modal('hide');
            });

            $(document).on('keydown', '.basics-panel #GroupId', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            });

            $(document).on('keydown', '#search-last-name', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    $('.search-by-name').trigger('click');
                }
            });


            $(document).on('click', '.search-again', function (e) {
                e.preventDefault();
                M2.Account.setParticipantSearchMode('show-participant-search');
            });

            $(document).on("click", ".search-by-name", function (e) {
                e.preventDefault();
                var $lastNameInput = $('#' + $(this).data('name-field-id'));
                var modalTitle = $(this).data('modal-title');

                var lastName = $lastNameInput.val();
                $lastNameInput.val('');
                var participantSearchUrl = $('#ParticipantSearchUrl').val();
                var currentGroupId = $('#GroupId').val(); // prev GroupIdDB

                $.ajax({
                    url: participantSearchUrl,
                    data: {
                        GroupId: currentGroupId,
                        LastName: lastName
                    }
                }).done(function (data) {
                    resetCampaignParticipant();
                    if (data.showPopup) {
                        M2.Modal.create('find-participant-overlay', modalTitle, data.viewUrl);
                    } else {
                        $('.participant-search-container .last-name input[type=text]').val(lastName);
                        M2.Account.setParticipantSearchMode('participant-not-found');
                    }
                });
            });

            $(document).on("change", ".basics select", function () {
                const tmpTarget = $(this).attr("data-for");
                $("#" + tmpTarget).html($(this).find("option:selected").html());
            });

            $(document).on("blur", ".basics input.preview", function () {
                populatePreview();
            });

            if (M2.Util.exists($("#UnitId"))) {
                if (M2.Util.exists($("#GroupLookupUrl"))) {
                    $(document).on("change", "#UnitId", function (e) {
                        const currentUnit = $(this).val();
                        const getGroupUrl = $("#GroupLookupUrl").val();

                        if (currentUnit !== "") {
                            // Enable the teacher select
                            var $teacherSelect = $(".teacher-identifier select")
                            disableSelect2($teacherSelect, false);

                            $.ajax({
                                url: getGroupUrl,
                                data: {
                                    "unitId": currentUnit
                                }
                            }).done(function (data) {
                                if (data.length > 1) {
                                    // We have data, show the drop down and hide the first and last name inputs
                                    $(".basics-panel").removeClass("show-leader-entry");
                                    $(".basics-panel").addClass("show-leader-select");

                                    if ($("#teacherUnknownOnLoad").val() === "True") {
                                        $(".basics-panel").addClass("show-leader-entry");
                                    } else {
                                        $("#no-teacher").prop("checked", false);
                                    }

                                    $("input[type='hidden'][name='TeacherUnknown']").val(false);
                                    $("#TeacherLastNameSelect").html("");

                                    $.each(data, function () {
                                   
                                        // Disable any options with no groupId
                                        const disabledState = !this.groupId;
                                        const selectDisabledState = disabledState;

                                        const tmpCurrentOption = $('<option/>', {
                                            'val': this.groupId,
                                            'html': this.leaderName,
                                            'disabled': disabledState,
                                            'selected': selectDisabledState
                                        });
                                        if (this.LeaderName === $("#TeacherLastName").val() && !$("#no-teacher").is(':checked')) {
                                            tmpCurrentOption.attr("selected", "selected");
                                            $("#TeacherLastName").val("");
                                        }
                                        tmpCurrentOption.appendTo('#TeacherLastNameSelect');
                                    });
                                    $(".teacher-identifier select").trigger("change.select2");
                                } else {
                                    //There's no data, show the first and last name input
                                    $(".basics-panel").addClass("show-leader-entry");
                                    $(".basics-panel").removeClass("show-leader-select");
                                    $("#no-teacher").prop("checked", true);
                                    $("input[type='hidden'][name='TeacherUnknown']").val(true);
                                }

                                // Reset Unknown on load
                                $("#teacherUnknownOnLoad").val("False");

                            });
                        } else {
                            restoreTeacherSelectDefault();
                        }
                    });
                }

                $(document).on("ready", function () {
                    $(".teacher-last-name select").select2({
                        placeholder: M2.Account.config.selectTeacherInstructionalText,
                        width: 'select.form-control'
                    }).change(function () {
                        $("#no-teacher").prop("checked", false);
                        $("#TeacherLastName").val("");
                        $(".basics-panel").removeClass("show-leader-entry");
                    });
                });
            }

            // If Nickanme changes through the flag
            $(document).one('change', '#ParticipantNickName', function () {
                $("#data-patch-model-changed").val("True");
            });
        },
        setParticipantSearchMode: function (mode) {
            M2.Account.updateInstructionalCopy(mode);

            const $participantSearchContainer = $('.participant-search-container');
            $participantSearchContainer
                .removeClass('group-not-selected')
                .removeClass('group-unknown')
                .removeClass('participant-not-found')
                .removeClass('participant-found')
                .removeClass('show-participant-search');

            const $participantNames = $('.participant-search-container .first-name input[type=text], .participant-search-container .last-name input[type=text]');

            const $submitBtn = $participantSearchContainer.closest('.inner-content').find('.participant-dependant.btn');
            $submitBtn.removeClass('disabled');

            var $GroupIdentifier = $('#GroupIdentifier'); // Prev GroupId
            var $GroupId = $('#GroupId'); // Prev GroupIdDB
            var $CampaignParticipantId = $('#CampaignParticipantId');
            var $AddScout = $('#AddScout');

            switch (mode) {
                case 'group-not-selected':

                    $GroupIdentifier.val('').trigger('change'); // Prev GroupId
                    $GroupId.val(''); // Prev GroupIdDB
                    $AddScout.val('False');
                    $participantSearchContainer.addClass('group-not-selected');
                    break;
                case 'group-unknown':
                    $GroupIdentifier.val('').trigger('change'); // Prev GroupId
                    $GroupId.val(''); // Prev GroupIdDB
                    $AddScout.val('True');
                    $participantNames.val('').prop('readonly', false);
                    $participantSearchContainer.addClass('group-unknown');
                    break;
                case 'participant-not-found':
                    $participantNames.prop("readonly", false);
                    $participantSearchContainer.addClass('participant-not-found');
                    $AddScout.val('True');
                    break;
                case 'participant-found':
                    $participantNames.prop('readonly', true);
                    $AddScout.val('False');
                    $participantSearchContainer.addClass('participant-found');
                    break;
                case 'show-participant-search':
                    $participantNames.val('').prop('readonly', true);
                    $participantSearchContainer.addClass('show-participant-search');
                    $AddScout.val('False');
                    $submitBtn.addClass('readonly');
                    break;
            }
        },
        // Set Group Search
        basicsOnComplete: function (result) {
            //successMsg();
        },
        updateInstructionalCopy: function (type) {
            var $instructionalContainer = $(".participant-details-container .instructional-copy");
            var instructionalText;

            switch (type) {
                case "group-not-selected":
                    instructionalText = M2.Account.config.GSA_GroupNotSelectedText;
                    break;
                case "group-unknown":
                    instructionalText = M2.Account.config.GSA_GroupUnknownText;
                    break;
                case "participant-not-found":
                    instructionalText = M2.Account.config.GSA_ParticipantNotFoundText;
                    break;
                case "participant-found":
                    instructionalText = M2.Account.config.GSA_ParticipantFoundText;
                    break;
            }
            $instructionalContainer.html(instructionalText);
        },
        updateParticipantBasicsOnSuccess: function (result) {
            const successStatus = $("#Success").val();
            if(successStatus == "True") M2.Util.successMsg();
            M2.Util.setSwitches();
        },
        updateParticipantBasicsSchoolOnSuccess: function (result) {
            M2.Util.successMsg();
            M2.Util.setSwitches();
        },
        updateParticipantAddressOnComplete: function (result) {
            //successMsg();
            //refreshToDoList();
        },
        verifyCouncilOnSuccess: function (result) {
            $(".field-grp.zip-status .status-icon").removeClass("success, failure");

            function registrationFailure() {
                $(".field-grp.zip-status .status-icon").removeClass("success").addClass("failure");
                $("#registration-form").hide();
                $('#verify-detail-form')[0].reset();
            }

            if ($("#hidden-zip-success").val() === "True") {
                var zipType = $("#hidden-zip-type").val();

                switch (zipType) {
                    case "ZipDoesNotExist":  // No associated council for this zip
                        $(".verify-zip-msg").html(M2.Account.config.noCouncilText).fadeIn("slow");
                        registrationFailure();
                        break;
                    case "ZipDoesNotMatch": // Current Council is incorrect, migrating to new council
                        if (returningPartipant) $(".verify-zip-msg").html(M2.Account.config.wrongCouncilReturningText).fadeIn("slow");
                        else $(".verify-zip-msg").html(M2.Account.config.wrongCouncilText).fadeIn("slow");
                        registrationFailure();
                        break;
                    case "ZipIsMatch": //Matches
                        $(".field-grp.zip-status .status-icon").removeClass("failure").addClass("success");

                        if (safetyVideoPledge) {
                            $("#safety-video-step").removeClass("hidden").slideDown();
                            const player = M2.Video.getPlayer('safety-player');

                            if (player) {
                                player.ready().then(function () {
                                    window.setTimeout(function () {
                                        player.play();
                                    }, 800);
                                });

                                player.on('ended', function () {
                                    $.ajax({
                                        url: $("#data-url").val()
                                    }).done(function (data) {
                                        $(".proceed-past-training-video .btn.disabled").removeClass("disabled").text("Next");
                                    });
                                });
                            }
                        } else if (safetyPledge) {
                            $("#safety-pledge-guardian-step").removeClass("hidden").slideDown(function () {
                                activateOnScroll($('.guardian-safety-pledge-container'), $(".proceed-past-guardian-pledge a.btn"));
                            });
                        }
                        else if (!returningPartipant) $("#registration-form").removeClass("hidden").slideDown();
                        else if (returningPartipant && !safetyPledge) {
                            getReturningUserUrl().done(function (data) {
                                const returnUrl = data;
                                window.location.href = returnUrl;
                            });
                        }
                        break;
                }
            } else {
                $("#registration-form").hide();
                $('#verify-detail-form')[0].reset();
            }
        },
        verifySchoolOnSuccess: function (result) {
            $(".yes.disabled").removeClass("disabled").removeAttr('disabled');
            if ($("#hidden-details-success").val() === "True") {
                var redirect = $("#hidden-redirect-url").val();
                window.location = redirect;
            } else {
                $('.modal').modal('hide');
            }
        },
        verifyDetailsOnSuccess: function (result) {
            $(".yes.disabled").removeClass("disabled").removeAttr('disabled');
            if ($("#hidden-details-success").val() === "True") {
                var redirect = $("#hidden-redirect-url").val();
                window.location = redirect;
            } else {
                $('html,body').animate({
                    scrollTop: $('.error-container').offset().top
                }, 1000);
                $('.modal').modal('hide');
                setUpAgeChooser();
            }
        },
        savePatchAddressOnSuccess: function (result) {
            if ($("#hidden-success").val() === "True") {
                $(".patch-callout-content").fadeOut("slow", function (e) {
                    $(".patch-callout-msg").html(M2.Account.config.addressEnteredText).fadeIn("slow").delay(2500).queue(function (e) {
                        $("#patch-callout-container").slideUp();
                    });
                });
            }
        },
        resetCampaignVideoSwitches: function () {
            setModalSwitches("set-storefront-video", M2.CampaignMedia.saveVideoStorefrontStatus);
        }
    };
})(jQuery);

$(function () {
    M2.Account.init();
});